import api from "./api";

const pageSize = 15;

export async function fetchHistory(
  pageNumber: number,
  filters: any
): Promise<any> {
  let url = "";
  const params: any = {
    page: pageNumber,
    pageSize,
    protocol: filters.protocol || null,
    document: filters.document || null,
    startDate: filters.startDate || null,
    endDate: filters.endDate || null,
    status: filters.status || null,
    deviceId: filters.deviceId || null,
    geoLocalizacao: filters.geoLocalizacao || null,
    ip: filters.ip || null ,
    cpf: filters.cpf || null,
    deviceIp: filters.deviceIp || null,
  };

  url = `/ConsultationLog/paged`;

  const response = await api.get(url, { params });
  return response;
}

export async function concluirConsulta(protocol: string): Promise<void> {
  await api.put(`/ConsultationLog/AlterStatus?protocol=${protocol}`);
}